import React from "react";
import TextInput from './TextInput'
import SelectInput from './SelectInput'
import FixButton from './Button'
import Cookies from 'universal-cookie';
import Utils from '../utils/utils';
import getCorsi from '../services/getCorsi';
import addStudente from "../services/addStudente";
import addUtente from "../services/addUtente";
import translateString from "../utils/Locales";
import checkUserToken from "../services/checkUserToken";
import addAnagraficaFatture from "../services/addAnagraficaFatture";
import getClient from "../services/getClient";

let t = translateString;

export default class NewStudentWidget extends React.Component {

    constructor (props){
        super(props);

        this.state = {
            visible: false,
            nome: '', 
            cognome: '', 
            codiceFiscale: '', 
            corsi: [], 
            mail: '', 
            mail2: '', 
            mail2Tipo: '', 
            indirizzo: '',
            citta: '', 
            renderIndex: 0,
            resizeIndex: 0,
            isMobile: false,
        };
    }

    handleResize() {
        if (window.innerWidth <= 718) {
            this.setState({ isMobile: true });
        } else {
            this.setState({ isMobile: false });
        }
    }

    async componentDidMount(){

        window.addEventListener('resize', () => this.handleResize());
        
        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });

        this.sessoArray = [];

        this.sessoArray.push({ value: 'M', label: t('M') });
        this.sessoArray.push({ value: 'F', label: t('F') });
        this.sessoArray.push({ value: 'A', label: t('A') });

        this.corsi = await getCorsi(username, token);
        this.corsiArray = [];
        this.corsi.map(r => {
          this.corsiArray.push({ value: r.id, label: r.name.replace(/\\/g, '') });
        });

        this.setState({ corsiArray: this.corsiArray, visible: this.props.visible, sessoArray: this.sessoArray, sesso: { value: 'A', label: t('A') } });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', () => this.handleResize());
    }

    shouldComponentUpdate() {

        if (this.state.renderIndex === 2) {
            return false;
        } else {
            this.setState({ renderIndex: this.state.renderIndex + 1 });
            return true;
        }
    }

    render() {

        return ( 
        <div key={Math.random()} style={{ minHeight: '600px', display: this.state.visible ? 'block' : 'none' }} >
            <div style={container} onClick={() => { this.setState({ visible: false }); this.props.onDone(); }}>
                <div style={ this.state.isMobile ? mainClassMobile : mainClass} onClick={(e) => e.stopPropagation()}>
                <div style={closeBtn} onClick={() => {
                this.setState({visible: false});
                this.props.onDone();
            }}>
                <img alt="" src={ require('../images/close_icon.png')} style={{ width: 30, height: 30, cursor: 'pointer' }} />
            </div>
            <div style={{ marginTop: '10px' }}>
                <div style={windowTitle}>{t('nuovo_studente')}</div>
                <div style={{ display: 'flex', marginLeft: 5, marginBottom: 0, marginTop: -10 }}>
                    <img alt="" src={ require('../images/question_icon.png') } style={{ width: 10, height: 10, marginRight: 5, marginTop: 1 }} />
                    <p style={{ fontSize: 10, color: 'darkgray', maxWidth: '80%' }}>{t('nuovo_studente_info')}</p><br/>
                </div>
                <div style={{ display: this.state.isMobile ? 'inherit' : 'flex', marginTop: '5px' }}>
                <div>
                <TextInput name={''} value={this.state.nome} style={{ borderTop: 0, borderLeft: 0, borderRight: 0, width: '290px', borderBottom: '1px solid lightgrey' }}
                    placeholder={t('nome') + ' (*)'}
                    onChange={(text) => { this.setState({ nome: text })}
                } />
                <TextInput name={''} value={this.state.cognome} style={{ borderTop: 0, borderLeft: 0, borderRight: 0, width: '290px', borderBottom: '1px solid lightgrey' }}
                    placeholder={t('cognome') + ' (*)'}
                    onChange={(text) => { this.setState({cognome: text})}
                } />
                <br/>
                <TextInput name={''} value={this.state.codiceFiscale} style={{ borderTop: 0, borderLeft: 0, borderRight: 0, width: '290px', borderBottom: '1px solid lightgrey' }}
                    placeholder={t('codice_fiscale')}
                    onChange={(text) => { this.setState({codiceFiscale: text})}
                } />
                <TextInput name={''} value={this.state.indirizzo} style={{ borderTop: 0, borderLeft: 0, borderRight: 0, width: '290px', borderBottom: '1px solid lightgrey' }}
                    placeholder={t('indirizzo')}
                    onChange={(text) => { this.setState({indirizzo: text})}
                } />
                <TextInput name={''} value={this.state.citta} style={{ borderTop: 0, borderLeft: 0, borderRight: 0, width: '290px', borderBottom: '1px solid lightgrey' }}
                    placeholder={t('citta')}
                    onChange={(text) => { this.setState({citta: text})}
                } />
                <TextInput name={''} value={this.state.mail} style={{ borderTop: 0, borderLeft: 0, borderRight: 0, width: '290px', borderBottom: '1px solid lightgrey' }}
                    placeholder={'Mail'}
                    onChange={(text) => { this.setState({mail: text})}
                } />
                </div>
                <div style={{ marginLeft: this.state.isMobile ? '0px' : '30px' }}>
                <div style={{ marginTop: this.state.isMobile ? '0px' : '-18px', marginBottom: 3 }} key={Math.random()}>
                    <SelectInput 
                        ref={this.selectRef}
                        value={this.state.sesso} 
                        name={t('sesso')} 
                        hidable={false}
                        options={this.state.sessoArray} 
                        onChange={(option) => 
                            this.setState({ sesso: option })} 
                    />
                    <SelectInput 
                        ref={this.selectRef}
                        value={this.state.corsi} 
                        name={t('corsi')} 
                        hidable={false}
                        options={this.state.corsiArray} 
                        isMulti={true}
                        onChange={(option) => 
                            this.setState({corsi: option})} 
                        />
                </div>
                <TextInput name={''} value={this.state.mail2} style={{ borderTop: 0, borderLeft: 0, borderRight: 0, width: '290px', borderBottom: '1px solid lightgrey' }}
                    placeholder={'Mail 2'}
                    onChange={(text) => { this.setState({mail2: text})}
                } />            
                {/*<TextInput name={''} value={this.state.mail2Tipo} style={{ borderTop: 0, borderLeft: 0, borderRight: 0, width: '290px', borderBottom: '1px solid lightgrey' }}
                    placeholder={t('mail_note')}
                    onChange={(text) => { this.setState({mail2Tipo: text})}
                } />*/}
                <TextInput name={''} value={this.state.telefono} style={{ borderTop: 0, borderLeft: 0, borderRight: 0, width: '290px', borderBottom: '1px solid lightgrey' }}
                    placeholder={t('telefono')}
                    onChange={(text) => { this.setState({telefono: text})}
                } />
                <TextInput name={''} value={this.state.telefono2} style={{ borderTop: 0, borderLeft: 0, borderRight: 0, width: '290px', borderBottom: '1px solid lightgrey' }}
                    placeholder={t('telefono') + ' 2'}
                    onChange={(text) => { this.setState({telefono2: text})}
                } />
                <TextInput name={''} value={this.state.telefono2Tipo} style={{ borderTop: 0, borderLeft: 0, borderRight: 0, width: '290px', borderBottom: '1px solid lightgrey' }}
                    placeholder={t('telefono_note')} 
                    onChange={(text) => { this.setState({telefono2Tipo: text})}
                } />
                </div>
                </div>
                <br/>
                <FixButton title={t('salva')} callback={() => this.saveStudente() } />
            </div>
                </div>
            </div>
        </div>
        )
    }

    async saveStudente() {

        if (this.state.nome !== '' && this.state.cognome !== '') {
            const cookies = new Cookies();
            const username = cookies.get('username', { path: '/' });
            const token = cookies.get('token', { path: '/' });

            var strCorsi = "";
            this.state.corsi && this.state.corsi.forEach(c => {
                strCorsi += c.value + ";";
            });

            let ret = await addStudente(username, token, this.state.cognome, this.state.nome, this.state.sesso.value, strCorsi, this.state.mail, this.state.mail2Tipo, this.state.mail2, 
                this.state.indirizzo, this.state.citta, this.state.codiceFiscale ? this.state.codiceFiscale.toUpperCase() : '', this.state.telefono, this.state.telefono2Tipo, this.state.telefono2);

            var newUsername = await Utils.generateUsername(username, token, this.state.nome, this.state.cognome);
            var password = Utils.generatePassword();
            var sec_token = Utils.generateUserToken();
            var res = await checkUserToken(username, token, sec_token);
            while(res.result !== 'ok') {
                sec_token = Utils.generateUserToken();
                res = await checkUserToken(username, token, sec_token);
            }
            await addUtente(username, token, '', '', newUsername, password, 1, ret.id, sec_token);
            
            let cliente = await getClient('', '', cookies.get('db', { path: '/' }));
            if (cliente.fatturazione_attiva === '1') {
                await addAnagraficaFatture(username, token, ret.id, 'clienti', this.state.nome + ' ' + this.state.cognome, this.state.indirizzo, this.state.citta, this.state.mail, this.state.telefono, this.state.codiceFiscale, '');
            }
        
            if (ret.result == 'ok'){
                this.setState({ visible: false });
                this.props.onDone();
            } else {
                Utils.showError(t('errore_imprevisto'));
            }
        } else {
            Utils.showInfo(t('verifica_dati'));
        }
    }

}

const windowTitle = {
    color: 'darkgrey', 
    fontSize: 30, 
    fontWeight: 'bold', 
    fontFamily: 'Teko', 
    textAlign:'left', 
    marginLeft: 5, 
    marginBottom: 10,
}

const mainClass = {
    
    position: 'absolute',
    top: '90px',
    left: 'calc((100% - 700px)/2)', 
    height: '560px',
    background: 'white',
    padding: '2%', 
    width: '700px',
    minWidth: '700px',
    boxShadow: '0px 2px 10px darkgrey',
    borderRadius: '10px', 
    overflowX: 'hidden', 
    overflowY: 'scroll',
}

const mainClassMobile = {
    
    position: 'absolute',
    top: '90px',
    left: 'calc((100% - 365px)/2)', 
    height: '600px',
    background: 'white',
    padding: '2%', 
    width: '365px',
    minWidth: '360px',
    boxShadow: '0px 2px 10px darkgrey',
    borderRadius: '10px', 
    overflowX: 'hidden', 
    overflowY: 'scroll',
}

const container = {
    position: 'fixed', 
    display: 'block', 
    top: 0,
    left: 0, 
    bottom: 0, 
    right: 0,
    minWidth: '100%', 
    minHeight: '100%', 
    backgroundColor: '#3C3C3C4D',
    overflowX: 'hidden', 
    overflowY: 'scroll',
}

const closeBtn = {
    position: 'absolute',
    right: 10,
    top: 10,
    padding: 10,
    cursor: 'pointer', 
    zIndex: 999, 
}